
/**
 * @description: 常用正则表达式
 */

 export const emailRegExp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

 export const phoneRegExp = /^1[23456789]\d{9}$/

 export const httpRegExp = /(http|https):\/\/([\w.]+\/?)\S*/

 export const passwordRegExp = /^(?![0-9]+$)(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/